import { createFileRoute, redirect } from '@tanstack/react-router'

import i18n from '@/i18n'
import {
  SchoolSettingsView,
  SchoolYearsView,
  schoolYearsFilterSchema
} from '@/modules/schoolSettings'
import { getMetaWithPageTitle } from '@/utils/get-page-title'
import { isFeatureFlagEnabled } from '@/utils/is-feature-flag-enabled'

export const Route = createFileRoute('/_auth/school-settings/years/')({
  validateSearch: schoolYearsFilterSchema,
  component: () => (
    <SchoolSettingsView>
      <SchoolYearsView />
    </SchoolSettingsView>
  ),
  beforeLoad: async () => {
    if (!isFeatureFlagEnabled('IS_SCHOOL_YEARS_MODULE_ENABLED'))
      throw redirect({ replace: true, to: '/' })
  },
  head: () =>
    getMetaWithPageTitle([
      i18n.t('title.school-settings', { ns: 'schoolSettings' }),
      i18n.t('title.school-years', { ns: 'schoolSettings' })
    ])
})
